var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.colors,"label":_vm.label,"rules":_vm.required ? [_vm.rules.required] : []},on:{"select":function($event){return _vm.$emit('input', _vm.returnValue)}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-badge',{attrs:{"inline":"","color":item}})]}},{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('v-badge',{attrs:{"inline":"","color":item}})]}}]),model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []

export { render, staticRenderFns }